@for (item of items(); track item.id; let i = $index) {
    <div [class]="item.backgroundColor ? item.backgroundColor + ' md:bg-primary-400' : 'bg-primary-400'">
        <div
            class="dark flex container items-center gap-5.5 text-center text-white tracking-[0.5px] overflow-y-hidden content-start justify-center min-h-12">
            <div
                class="font-ci translate-y-[0.1em] [&>*:last-child]:mb-0 [&_a]:underline [&_a]:hover:text-primary-300"
                [innerHTML]="item.html"></div>
            <big-ui-button
                [buttonStyle]="'tertiary icon'"
                [id]="item.id"
                (clicked)="closeTopBar(i)"
                class="leading-[0]">
                <span class="sr-only">{{ closeMessageTranslation() }}</span>
                <big-icon
                    [icon]="iconClose"
                    [size]="'w-5'"
                    class="fill-white" />
            </big-ui-button>
        </div>
    </div>
}
